export default (superclass) => class extends superclass {

  static outlets = ['consultation']

  connect() {
    super.connect()

    const isNested = this.element.parentElement?.closest(
      `[data-controller~="${this.identifier}"]`
    )

    if (!isNested) this.jumpToFirstError()
  }

  jumpToFirstError() {
    const firstError = Array.from(this.element.querySelectorAll('.a-ds2-input__error, .a-input__error'))
      .find((el) => el.checkVisibility())
    const container = firstError?.closest('.a-ds2-input, .a-input, fieldset, .c-required')

    if (!firstError) {
      if (this.hasConsultationOutlet) this.consultationOutlet.scrollToTop()
      return
    }

    if (!container) {
      const section = firstError.closest('.c-required')?.parentElement
      const nearbyInput = this.#findInput(section)
      if (nearbyInput) {
        this.#scrollToInput(nearbyInput)
      } else {
        this.scrollTo(firstError)
      }
      return
    }

    const targetInput = this.#findInput(container)
    if (targetInput) {
      this.#scrollToInput(targetInput)
    } else {
      this.#scrollTo(container)
    }
  }

  #findInput(el) {
    return el?.querySelector('input:not([type="hidden"]), select, textarea')
  }

  #scrollTo(el) {
    el.scrollIntoView({ behavior: 'smooth', block: 'center' })
  }

  #scrollToInput(el) {
    this.#scrollTo(el)
    el.focus({ preventScroll: true })
  }

}
